var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 28H21.882C22.5672 28 23.1936 28.3871 23.5 29C23.8064 29.6129 24.4328 30 25.118 30H30.882C31.5672 30 32.1936 29.6129 32.5 29C32.8064 28.3871 33.4328 28 34.118 28H37.5M24.9666 20H31.0334C32.1103 20 32.6487 20 33.1241 20.164C33.5445 20.309 33.9274 20.5456 34.2451 20.8567C34.6043 21.2086 34.8451 21.6902 35.3267 22.6534L37.4932 26.9865C37.6822 27.3645 37.7767 27.5535 37.8434 27.7515C37.9026 27.9275 37.9453 28.1085 37.971 28.2923C38 28.4992 38 28.7105 38 29.1331V31.2C38 32.8802 38 33.7202 37.673 34.362C37.3854 34.9265 36.9265 35.3854 36.362 35.673C35.7202 36 34.8802 36 33.2 36H22.8C21.1198 36 20.2798 36 19.638 35.673C19.0735 35.3854 18.6146 34.9265 18.327 34.362C18 33.7202 18 32.8802 18 31.2V29.1331C18 28.7105 18 28.4992 18.029 28.2923C18.0547 28.1085 18.0974 27.9275 18.1566 27.7515C18.2233 27.5535 18.3178 27.3645 18.5067 26.9865L20.6733 22.6534C21.1549 21.6902 21.3957 21.2086 21.7549 20.8567C22.0726 20.5456 22.4555 20.309 22.8759 20.164C23.3513 20 23.8897 20 24.9666 20Z",
    stroke: "#006CBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9FAFB",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIcon);
export default __webpack_public_path__ + "static/media/no-data-icon.e3839b2ff6f408d2b9d83aaa483d9096.svg";
export { ForwardRef as ReactComponent };